import { ChatNavIcon } from "@/components/SVGComponents/MemberIcons";
import styles from "./Chat.module.scss";

const Chat = () => {
  return (
    <section className={styles.page}>
      <div className={styles.contentCard}>
        <span className={styles.iconWrap}>
          <ChatNavIcon />
        </span>
        <h1>Chat Coming Soon</h1>
        <p>
          This space is ready for member conversations and dinner follow-ups, styled
          to match the new BFC experience.
        </p>
      </div>
    </section>
  );
};

export default Chat;
